import { map } from 'ramda'

export const getPersonList = map(person => ({
  '@type': 'Person',
  name: person.name
}))
